import { render, staticRenderFns } from "./CompanyEdit.vue?vue&type=template&id=f9bd7746&"
import script from "./CompanyEdit.vue?vue&type=script&lang=ts&"
export * from "./CompanyEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9bd7746')) {
      api.createRecord('f9bd7746', component.options)
    } else {
      api.reload('f9bd7746', component.options)
    }
    module.hot.accept("./CompanyEdit.vue?vue&type=template&id=f9bd7746&", function () {
      api.rerender('f9bd7746', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CompanyEdit.vue"
export default component.exports